import { render, staticRenderFns } from "./comShopInfo.vue?vue&type=template&id=2e3f2f7e&scoped=true"
import script from "./comShopInfo.vue?vue&type=script&lang=js"
export * from "./comShopInfo.vue?vue&type=script&lang=js"
import style0 from "./comShopInfo.vue?vue&type=style&index=0&id=2e3f2f7e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e3f2f7e",
  null
  
)

export default component.exports